module.exports = {"id":"209729","name":"Barrie McKay","rating":"72","photo":"./data/images/photos/1/209729.png","club":{"name":"Notting. Forest","logo":"./data/images/clubs/Notting.Forest.png"},"positions":["MG","AD","MD","AG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BarrieMcKay0.json
// module id = 533
// module chunks = 0